import { API_REVIEW_URL, CreateOrReadResponseBody, GET_USER_REVIEW_ELIGBLITY } from "../utils/constant";
import { getJson } from "../utils/network";

export async function getUserReviewEligblity(storeId: string) {
    const path = GET_USER_REVIEW_ELIGBLITY(storeId);
    let token = window.location.search.split("shopifyToken=")[1] || undefined;

    if(window.shopify) {
        token = await window.shopify?.idToken?.();
    }

    const { response } = await getJson<CreateOrReadResponseBody<any>>(path, undefined, API_REVIEW_URL, token);

    return response;
}